import EventQueue from "./event-queue";
export default EventQueue;
